<template>
    <div class="header-pwa">
      <div class="header-pwa-title">

          <!-- 左邊圖示 -->
          <div class="header-left">
            <!-- 預設返回 -->
            <span v-if="isBack" @click="$router.back()" class="pwa-back icon-arrow_left" ></span>
            <!-- 客製返回 -->
            <span v-if="showBack" @click="handleClickBack" class="pwa-back icon-arrow_left"></span>
          </div>

          <div class="header-pwa-home">
              <!-- 圖示 -->
              <img :src="'static/img/icon-192.png'"  :alt="'雲林數位農業行動平台'"> 
              <!-- 標題 -->
              <div class="header-title">{{ title }}</div>
          </div>

          <!-- 右邊圖示_-->
          <div class="header-right" >
              &nbsp;
          </div>
      </div>
    </div>    
</template>
<script>
export default {
  methods: {

    handleClickBack() {
      //alert("子層內建事件");
      this.$emit("clickBack"); // 再通知父層
    }
  },  
  props: {
    title: {
      type: String,
      default: ''
    },
    //右方返回(預設)是否呈現
    isBack: {
      type: Boolean,
      default: false
    },
    //右方返回(客製)是否呈現
    showBack: {   
      type: Boolean,
      default: false
    },

  }
}
</script>
